import routes from 'common/constants/routing.constants';
import {
  PersonSvg,
  ChartSvg,
  WalletSvg,
  CardSvg,
  BonusSvg,
  RewardSvg,
  CopySvg,
  PieChartSvg,
  TooltipSvg,
} from 'common/ui/themes/disona/icons/index';

const PRIMARY_PAGES = [
  { ...routes.profile, Icon: PersonSvg },
  { ...routes.trading, Icon: ChartSvg },
  { ...routes.accounts, Icon: WalletSvg },
  { ...routes.operations, Icon: CardSvg },
];

const SECONDARY_PAGES = [
  { ...routes.bonus, Icon: BonusSvg },
  { ...routes.rewards, Icon: RewardSvg },
  { ...routes.copyTrading, Icon: CopySvg },
  { ...routes.analytics, Icon: PieChartSvg },
  { ...routes.faq, Icon: TooltipSvg },
];

export { PRIMARY_PAGES, SECONDARY_PAGES };
